import { ClientResponseModelMock } from 'modules/clients/types/client.interfaces';

export const mockClientResponse: ClientResponseModelMock[] = [
  {
    clientID: 1,
    clientFirstName: 'Albertus',
    clientLastName: 'Barnard',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity - (Value Plus Range)',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2016-04-12')
      },
      {
        investmentName:
          'Personal Portfolio Retirement Annuity: Vested Component (Non-vested rights)',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2018-11-03')
      }
    ]
  },
  {
    clientID: 2,
    clientFirstName: 'Abraham',
    clientLastName: 'van der Westhuizen',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2017-02-18')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity IWA Cautious Portfolio (Comp.)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2019-07-29')
      },
      {
        investmentName: 'Personal Portfolio Retirement Annuity: Retirement Component',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2021-01-12')
      }
    ]
  },
  {
    clientID: 3,
    clientFirstName: 'Christiaan',
    clientLastName: 'Louw',
    investments: [
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Retirement Component',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2015-09-09')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Vested Component (Non-vested rights)',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2018-06-14')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2020-03-05')
      }
    ]
  },
  {
    clientID: 4,
    clientFirstName: 'Rachelle',
    clientLastName: 'Goosen',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity IWA Cautious Portfolio (Comp.)',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2014-10-20')
      },
      {
        investmentName: 'Personal Portfolio Retirement Annuity: Retirement Component',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2016-05-02')
      }
    ]
  },
  {
    clientID: 5,
    clientFirstName: 'Barbara',
    clientLastName: 'Meyer',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity - (Value Plus Range)',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2017-12-17')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Vested Component (Non-vested rights)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2019-04-11')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2022-07-23')
      }
    ]
  },
  {
    clientID: 6,
    clientFirstName: 'Johanna',
    clientLastName: 'Swart',
    investments: [
      {
        investmentName:
          'Personal Portfolio Retirement Annuity: Vested Component (Non-vested rights)',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2015-03-02')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Retirement Component',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2018-05-22')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity IWA Cautious Portfolio (Comp.)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2020-09-10')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2023-02-15')
      }
    ]
  },
  {
    clientID: 7,
    clientFirstName: 'John',
    clientLastName: 'Doe',
    investments: [
      {
        investmentName: 'Personal Portfolio Retirement Annuity: Retirement Component',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2016-11-08')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Vested Component (Non-vested rights)',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2019-08-19')
      }
    ]
  },
  {
    clientID: 8,
    clientFirstName: 'Jane',
    clientLastName: 'Smith',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2013-01-17')
      },
      {
        investmentName:
          'Personal Portfolio Retirement Annuity: Vested Component (Non-vested rights)',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2015-06-20')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Retirement Component',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2019-03-11')
      }
    ]
  },
  {
    clientID: 9,
    clientFirstName: 'Kathrine',
    clientLastName: 'Green',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity - (Value Plus Range)',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2020-07-07')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity IWA Cautious Portfolio (Comp.)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2021-10-30')
      }
    ]
  },
  {
    clientID: 10,
    clientFirstName: 'George',
    clientLastName: 'Taylor',
    investments: [
      {
        investmentName: 'Personal Portfolio Retirement Annuity: Retirement Component',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2015-09-15')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2017-12-01')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Vested Component (Non-vested rights)',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2022-06-28')
      }
    ]
  },
  {
    clientID: 11,
    clientFirstName: 'Michael',
    clientLastName: 'Barnard',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity - (Value Plus Range)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2016-02-11')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Retirement Component',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2019-11-21')
      },
      {
        investmentName:
          'Personal Portfolio Retirement Annuity: Vested Component (Non-vested rights)',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2021-08-13')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2023-03-04')
      }
    ]
  },
  {
    clientID: 12,
    clientFirstName: 'Jessica',
    clientLastName: 'Doe',
    investments: [
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Vested Component (Non-vested rights)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2012-12-12')
      },
      {
        investmentName: 'Personal Portfolio Retirement Annuity: Retirement Component',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2016-06-01')
      }
    ]
  },
  {
    clientID: 13,
    clientFirstName: 'Albertus',
    clientLastName: 'Queen',
    investments: [
      {
        investmentName: 'Personal Portfolio Living Annuity IWA Cautious Portfolio (Comp.)',
        investmentPlanNumber: 15268,
        inceptionDate: new Date('2014-07-15')
      },
      {
        investmentName: 'Personal Portfolio Living Annuity - (Value Plus Range)',
        investmentPlanNumber: 17845,
        inceptionDate: new Date('2017-11-09')
      },
      {
        investmentName:
          'Personal Portfolio Retirement Annuity: Vested Component (Non-vested rights)',
        investmentPlanNumber: 75025,
        inceptionDate: new Date('2021-03-19')
      },
      {
        investmentName: 'IWA Cautious Portfolio (Comp.): Retirement Component',
        investmentPlanNumber: 63845,
        inceptionDate: new Date('2022-10-12')
      }
    ]
  }
];
